"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPaymentStartDate = exports.getMinPolicyStartDate = void 0;
var _dayjs = _interopRequireDefault(require("dayjs"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var minPetAgeLimitInDay = 56;
var minPetAgeInDay = 42;
var policyStartDateForwardDays = 14;
var maxPetAgeInYear = 12;

/** 
 * 
 * @param {*} pets 
 * @param {*} config 
 * @returns {string} minPolicyStartDate in iso format
 */
var getMinPolicyStartDate = exports.getMinPolicyStartDate = function getMinPolicyStartDate() {
  var pets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (!minPetAgeInDay || !minPetAgeLimitInDay || !policyStartDateForwardDays) {
    throw new Error('Some of the configs are not provided');
  }
  var youngestPet = pets.reduce(function (acc, pet) {
    return (0, _dayjs["default"])(acc.petDOB).isBefore(pet);
  }, []);
  var youngestAge = (0, _dayjs["default"])().subtract((0, _dayjs["default"])(youngestPet.petDOB)).valueOf();
  var maxAge = (0, _dayjs["default"])(minPetAgeLimitInDay).valueOf();
  var minAge = (0, _dayjs["default"])(minPetAgeInDay).valueOf();
  if (youngestAge < maxAge && youngestAge >= minAge) {
    for (var i = 0; i <= policyStartDateForwardDays; i += 1) {
      var minStartDate = (0, _dayjs["default"])().add(i, 'd').startOf('day');
      var diff = (0, _dayjs["default"])(youngestPet.petDOB).diff(minStartDate, 'days', true);
      if (diff === -minPetAgeLimitInDay) {
        return minStartDate.toISOString();
      }
    }
  }
  return (0, _dayjs["default"])().toISOString();
};

/**
 * 
 * @param {string} policyStartDate 
 * @returns {string} policyStartDate in ISO format
 */
var getPaymentStartDate = exports.getPaymentStartDate = function getPaymentStartDate(policyStartDate) {
  return (0, _dayjs["default"])(policyStartDate).add(1, 'day').startOf('day').toISOString();
};